import { styled, Theme, CSSProperties } from '@nexelem/deprecated-theme';
import { IconButton } from '@nexelem/components';

export const StyledIconButton = styled(IconButton)<{ isActive?: boolean }>(({ isActive, theme }) => {
  const typedTheme = theme as Theme;
  const { getColor } = typedTheme.palette;
  const { active } = typedTheme.client.buttons.primaryButton.text.states;

  const baseStyled: CSSProperties = {
    border: 0,
    display: 'flex',
    background: 'none',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(5, 2),
    cursor: 'pointer',
    verticalAlign: 'middle',
  };
  if (isActive) {
    return {
      ...baseStyled,
      backgroundColor: getColor(active.backgroundColor),
      color: getColor(active.color),
      i: {
        opacity: 1,
      },
    };
  }
  return baseStyled;
});
export const StyledContainer = styled('div')(({ theme }) => {
  const typedTheme = theme as Theme;
  const { elevation } = typedTheme.palette;

  return {
    ...elevation.tiny,
    display: 'flex',
    background: '#fff',
    padding: theme.spacing(1),
    verticalAlign: 'middle',
    position: 'absolute',
    top: '0',
    left: '0',
    zIndex: 10,
    opacity: 0,
    gap: theme.spacing(1),
    backgroundColor: '#fff',
    borderRadius: '8px',
    transition: 'opacity 0.5s',
    height: theme.spacing(11),
    willChange: 'transform',
  };
});
